// Cookie name can be overridden by environment variable
// Authorization cookie name
export const AUTH_COOKIE = process.env.REACT_APP_COOKIE_NAME ? process.env.REACT_APP_COOKIE_NAME : 'auth_token';
